import { PilulaStatus } from "@/components/padroes";
import type { FolhaStatus } from "@/data/folha";

/**
 * Badge de status da competência: "Fechada" escuro, "Rascunho" com ponto
 * âmbar. Fechada com cadastro incompleto (PJ sem CNPJ...) vira "Fechada com
 * pendência", em âmbar.
 */
export const StatusFolha = ({
  status,
  comPendencia = false,
}: {
  status: FolhaStatus;
  comPendencia?: boolean;
}) =>
  status === "fechada" ? (
    comPendencia ? (
      <span
        className="inline-flex h-[22px] items-center whitespace-nowrap rounded-full border border-amber-500/40 bg-amber-500/10 px-2.5 text-xs font-semibold text-amber-800 dark:text-amber-300"
        title="Há colaboradores com cadastro incompleto (ex.: PJ sem CNPJ)"
      >
        Fechada com pendência
      </span>
    ) : (
      <span className="inline-flex h-[22px] items-center whitespace-nowrap rounded-full bg-foreground px-2.5 text-xs font-semibold text-background">
        Fechada
      </span>
    )
  ) : (
    <PilulaStatus cor="ambar" className="font-semibold">
      Rascunho
    </PilulaStatus>
  );
